import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M11.53 3.009a.7.7 0 0 1 .604.196l2.842 2.842 5.819 5.819a.7.7 0 0 1 0 .99l-7.94 7.939a.7.7 0 0 1-.99 0l-5.818-5.819-2.842-2.842a.7.7 0 0 1-.196-.604L4.09 4.673a.7.7 0 0 1 .582-.582L11.53 3.01ZM5.395 5.395l-.948 6.001 7.914 7.914 6.95-6.95-7.915-7.913-6.001.948Z"
            clipRule="evenodd"
        />
        <path fill="currentColor" d="M9 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
